export type LoggingLevel = 'trace' | 'debug' | 'info' | 'warn' | 'error' | 'fatal' | 'silent';

export const LoggingLevels = ['trace', 'debug', 'info', 'warn', 'error', 'fatal', 'silent'];
